/**
 * School Mobile App Release Request API Contract
 *
 * POST /v1/schools/:school_id/mobile-app/release-request
 *
 * A school admin asks staff to release the app's pending drafts (release lines
 * U9, R14, R15). No body: the request is for every draft pending at the moment
 * it is made. The request is recorded as an operations event and posted to
 * #app-operations; the pending draft rows are stamped with the request date,
 * which the field-status route then reports per field. A second request with
 * no save in between is the same request (`alreadyRequested`), and posts
 * nothing new. No pending drafts is 409 `NO_PENDING_DRAFTS`.
 */

import { z } from 'zod'
import { SchoolAppFieldKeySchema } from '../../schemas/entities/school-app-field-draft'

export const SchoolAppReleaseRequestResponseSchema = z.object({
  /** When the request was made: this call, or the earlier identical one. */
  requestedAt: z.string().datetime(),
  /** The fields the request covers, in key order. */
  fieldKeys: z.array(SchoolAppFieldKeySchema),
  /** True when an identical request (same fields, same saves) was already made. */
  alreadyRequested: z.boolean()
})
export type SchoolAppReleaseRequestResponse = z.infer<typeof SchoolAppReleaseRequestResponseSchema>
